import request from '@/router/axios';

export function fetchAccountTierList() {
  return request({
    url: 'admin/admin/member/tiers',
    method: 'get'
  })
}

export function fetchAccountTierByTierId(tierId) {
  return request({
    url: '/admin/admin/member/tier/' + tierId,
    method: 'get'
  })
}

export function addAccountTier(obj) {
  return request({
    url: '/admin/admin/member/tier',
    method: 'post',
    data: obj
  })
}

export function updateAccountTier(obj) {
  return request({
    url: '/admin/admin/member/tier',
    method: 'put',
    data: obj
  })
}

export function deleteAccountTierByTierId(tierId) {
  return request({
    url: '/admin/admin/member/tier/' + tierId,
    method: 'delete'
  })
}